const PORTAL_ID = 'cvt-card-gallery-modal-portal';
function getOrCreateModalPortal() {
    const existing = document.getElementById(PORTAL_ID);
    if (existing) {
        return existing;
    }
    const container = document.createElement('div');
    container.id = PORTAL_ID;
    document.body.appendChild(container);
    return container;
}
function removeModalPortalIfEmpty() {
    const container = document.getElementById(PORTAL_ID);
    if (!container) {
        return;
    }
    if (!container.hasChildNodes()) {
        container.remove();
    }
}

export { getOrCreateModalPortal, removeModalPortalIfEmpty };
